<template>
    <div class="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1"
         id="offcanvasAssignContact" aria-labelledby="offcanvasAssignContactLabel">
        <div class="offcanvas-header">
            <h4 class="offcanvas-title">
                {{ $trans.get('__JSON__.Edit contact locations') }}
            </h4>
            <button type="button" class="btn-close text-reset text-xs" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="list-group list-group-flush" v-if="contact">
                <div class="list-group-item d-flex align-items-center px-0">
                    <div class="me-4">
                        <div class="avatar rounded-circle">
                            <img :alt="contact.fullName" :src="contact.avatar" />
                        </div>
                    </div>
                    <div class="flex-fill">
                        <span class="d-block h6 font-semibold mb-1">
                            {{ contact.fullName }}
                        </span>
                        <span class="d-block text-sm text-muted">
                            {{ contact.email }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-5">
                <div class="form-group">
                    <label class="form-label" for="locations">
                        {{ $trans.get('__JSON__.Choose locations') }}
                    </label>

                    <vue-multiselect
                        id="locations"
                        label="name"
                        track-by="name"
                        group-values="locations"
                        group-label="name"
                        :options="locations"
                        v-model="selected"
                        multiple
                    />
                </div>
            </div>
        </div>
        <div class="modal-footer bg-surface-secondary">
            <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="offcanvas">
                {{ $trans.get('__JSON__.Cancel') }}
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="submit" :disabled="submitting">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="submitting"></span>
                <span v-else>{{ $trans.get('__JSON__.Save') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AssignContactLocations',
    data() {
        return {
            loading: false,
            submitting: false,


            contactId: null,
            contact: null,
            selected: [],
            locations: [],
        }
    },
    methods: {
        async fetch() {
            this.loading = true
            const { data } = await axios.get(`/api/contacts/${this.contactId}`)

            this.contact = data.contact
            this.selected = data.selected
            this.locations = data.locations
            this.loading = false
        },
        async submit() {
            if (! this.contactId) return
            this.submitting = true

            try {
                const { data } = await axios.post(`/api/contacts/${this.contactId}`, {
                    locations: this.selected.map(it => it.id),
                })

                window.toastr.success(data.message)

                await this.close()
            } catch (e) {
                window.toastr.error(e.response?.data.message)
            }

            this.submitting = false
        },
        async close() {
            let offcanvas = await bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('offcanvasAssignContact'))
            offcanvas.hide()
        },
    },
    mounted() {
        let offcanvas = document.getElementById('offcanvasAssignContact')
        offcanvas.addEventListener('show.bs.offcanvas', async event => {
            this.contactId = event.relatedTarget.dataset.contactId
            await this.fetch()
        })
    },
}
</script>
